/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateOtpAction, matchOtpRequestAction, toggleOtpModalAction } from 'app/redux/actions/ForgotPasswordAction';
import { RootState } from 'app/redux/store';
import ImagePath from 'app/utilities/imagePath';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InputComponent from '../InputComponent/InputComponent';
import './OtpForm.scss';

export interface OtpProps {
	phoneNumber: string,
}

export const time = 59;

const OtpForm = function init(props: OtpProps): React.ReactElement {
	const dispatch = useDispatch();
	const { phoneNumber } = props;
	const [canResendOtp, setCanResendOtp] = useState(false);
	const [timer, setTimer] = useState(time);
	const [form, setForm] = useState([
		{
			id: 'otp',
			formType: 'otp',
			placeholder: '',
			name: 'otp',
			apiErrorMessage: '',
            value: ''
		},
	]);
	const forgotPasswordState = useSelector((state: RootState) => state.forgotPasswordReducer);
	const { generateOtpState, matchOtpState } = forgotPasswordState;

	function checkValidation(): void {
        form.forEach((each) => {
            if (each.value.length > 5) {
                const payload = {
					otpCode: each.value,
					transactionId: generateOtpState.response.transactionId,
					recipient: phoneNumber,
					type: 'lender_institutional',
				};
				dispatch(matchOtpRequestAction(payload));
            }
        });
		const updateForm = [
			...form
		];
		setForm(updateForm);
	}

	function onChangeHandle(event: Record<string, string>): void {
        const fieldForm = form.find((field) => field.name === event.name);
        if (fieldForm) {
            fieldForm.value = event.value;

            checkValidation();
        }
    }

	function resendOtp(): void {
		setTimer(time);
		setCanResendOtp(false);
		dispatch(generateOtpAction(generateOtpState.payload));
	}

	useEffect(() => {
		if (timer > 0) {
			setTimeout(() => setTimer(timer - 1), 1000);
		} else {
			setCanResendOtp(true);
		}
	}, [timer]);

	useEffect(() => {
		if (matchOtpState.error) {
			form.forEach((each) => {
				each.apiErrorMessage = matchOtpState.error;
			});
			const updateForm = [...form];
			setForm(updateForm);
		}
	}, [matchOtpState.error]);

	function canResendOtpCheck(): React.ReactElement {
		if (canResendOtp) {
			return (
				<div>
					<span className="resend-otp-title mb-1">
						Tidak menerima kode verifikasi?
					</span>
					<button
						onClick={resendOtp}
						className="resend-otp btn-img"
						type="button"
					>
						<h4> Kirim Ulang </h4>
					</button>
				</div>
			);
		}
		return (
			<span className="resend-otp-title">
				Mohon tunggu dalam
				{' '}
				{ timer }
				{' '}
				detik untuk mengirim ulang
			</span>
		);
	}

	return (
		<div className="otpForm" data-testid="OtpForm">
			<div className="titleContainer">
				<h3> Masukkan Kode Verifikasi </h3>
				<button
					className="imageContainer btn"
					type="button"
					onClick={() => dispatch(toggleOtpModalAction(false))}
				>
					<img src={ImagePath.close.src} alt={ImagePath.close.alt} />
				</button>
			</div>
			<p>
				Kode verifikasi telah dikirim melalui SMS ke
				{' '}
				{phoneNumber}
			</p>
			<form>
				{ form.map((each) => (
					<InputComponent
						key={each.id}
						id={each.id}
						formType={each.formType}
						placeholder={each.placeholder}
						name={each.name}
						apiErrorMessage={each.apiErrorMessage}
                        value={each.value}
                        onChange={(event) => { onChangeHandle(event); }}
					/>
				))}
				{canResendOtpCheck()}
			</form>
		</div>
	);
};

export default OtpForm;
